function isRecord (value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null
}

function asString (value: unknown): string {
    if (typeof value === 'string') {
        return value
    }

    if (typeof value === 'number') {
        return String(value)
    }

    return ''
}

function getStatusFromMessage (value: unknown): number | null {
    const message = asString(value)

    if (!/^\d+$/.test(message)) {
        return null
    }

    return Number(message)
}

function getResponseData (error: unknown): unknown {
    if (!isRecord(error) || !isRecord(error.response)) {
        return null
    }

    return error.response.data
}

function getStatus (error: unknown): number | null {
    if (isRecord(error) && isRecord(error.response) && typeof error.response.status === 'number') {
        return error.response.status
    }

    if (error instanceof Error) {
        return getStatusFromMessage(error.message)
    }

    return getStatusFromMessage(error)
}

function getDetails (data: unknown): string[] {
    if (!isRecord(data) || !Array.isArray(data.details)) {
        return []
    }

    return data.details
        .map((detail) => asString(detail))
        .filter((detail) => detail.length > 0)
}

function getMessageFromData (data: unknown): string {
    if (typeof data === 'string') {
        return data.trim().startsWith('<') ? '' : data
    }

    if (!isRecord(data)) {
        return ''
    }

    return asString(data.error) || asString(data.message)
}

export interface NormalizedError {
    status: number | null;
    message: string;
    details: string[];
    isAuthError: boolean;
}

export function normalizeError (error: unknown): NormalizedError {
    const status = getStatus(error)
    const data = getResponseData(error)
    const details = getDetails(data)
    const message = details[0] ||
        getMessageFromData(data) ||
        (error instanceof Error ? error.message : asString(error)) ||
        (status !== null ? String(status) : 'Неизвестная ошибка')

    return {
        status,
        message,
        details,
        isAuthError: status === 401
    }
}

export function getErrorMessage (error: unknown): string {
    return normalizeError(error).message
}
